import type { Session, SupabaseClient } from '@supabase/supabase-js';

type AuthClient = Pick<SupabaseClient['auth'], 'getSession' | 'signOut'>;

export async function recoverSession(auth: AuthClient): Promise<Session | null> {
  const { data, error } = await auth.getSession();
  if (!error) return data.session;

  // A failed refresh can leave an unusable session in browser storage. Clear
  // only the local session so the app returns to login without a redirect loop.
  await auth.signOut({ scope: 'local' }).catch(() => undefined);
  return null;
}
